import * as types from "../types";
import advisorhq from "../../apis/advisorhq";
import * as notifications from "../../notifications";
import { SELECT_OPPORTUNITY } from "../types";
import { URLS } from "../../constants";
import {
  activeAccountIdSelector,
  activeCarrierFileSelector,
  activeCarrierSelector,
  activeOpportunityFileSelector,
  activeOpportunitySelector,
} from "../../reducers";
import { fetchAccount } from "./accounts";

export const fetchOpportunities = filters => async (dispatch, getState) => {
  dispatch({ type: types.LOADING, payload: { opportunities: true } });
  const response = await advisorhq.get("/life_settlement/api/opportunity/", {
    params: { ...filters },
  });
  dispatch({ type: types.FETCH_OPPORTUNITIES, payload: response.data });
  dispatch({ type: types.LOADING, payload: { opportunities: false } });
};

export const createOpportunity = values => async (dispatch, getState) => {
  dispatch({ type: types.LOADING, payload: { opportunities: true } });
  const endpoint = `/life_settlement/api/opportunity/`;
  const formData = new FormData();

  for (let key in values) {
    formData.append(key, values[key]);
  }

  if (values.files) {
    for (let i = 0; i < values.files.length; i++) {
      formData.append("files[]", values.files[i], values.files[i].name);
    }
  }

  const response = await advisorhq.post(endpoint, formData, {
    headers: {
      "Content-Type": "multipart/form-data",
    },
  });
  dispatch({ type: types.CREATE_OPPORTUNITY, payload: response.data });
  notifications.success("A new Opportunity was created");
  dispatch({ type: types.LOADING, payload: { opportunities: false } });
  return response.data;
};

export const editOpportunity = (id, newValues) => async (dispatch, getState) => {
  notifications.success("Saving...");
  if (newValues.files) {
    delete newValues.files;
  }
  const endpoint = `/life_settlement/api/opportunity/${id}/`;
  const response = await advisorhq.patch(endpoint, newValues);
  notifications.clearAll();
  dispatch({ type: types.EDIT_OPPORTUNITY, payload: response.data });
  notifications.success("Opportunity saved successfully");
};

export const selectOpportunity = id => async dispatch => {
  dispatch({ type: types.SELECT_OPPORTUNITY, payload: id });
  const endpoint = `/life_settlement/api/opportunity/${id}/`;
  const response = await advisorhq.get(endpoint);
  dispatch({ type: types.FETCH_OPPORTUNITY, payload: response.data });
};

export const clearSelectedOpportunity = () => async dispatch => {
  dispatch({ type: types.SELECT_OPPORTUNITY, payload: null });
};

export const deleteOpportunity = id => async (dispatch, getState) => {
  const endpoint = `/life_settlement/api/opportunity/${id}/`;
  await advisorhq.delete(endpoint);
  dispatch({ type: types.DELETE_OPPORTUNITY, payload: id });
  const inAccountDetail = window.location.pathname.includes(URLS.ACCOUNTS);
  if (inAccountDetail) {
    const activeAccountId = activeAccountIdSelector(getState());
    dispatch(fetchAccount(activeAccountId));
  }
};

/** Opportunity Files **/
export const deleteOpportunityFile = id => async (dispatch, getState) => {
  await advisorhq.delete(`/life_settlement/api/opportunity_file/${id}/`);

  // update opportunity files
  const activeOpportunity = activeOpportunitySelector(getState());
  let opportunityId = activeOpportunity && activeOpportunity.id;
  const opportunityResponse = await advisorhq.get("/life_settlement/api/opportunity/" + opportunityId + "/");
  dispatch({ type: types.FETCH_OPPORTUNITY, payload: opportunityResponse.data });
};

export const createOpportunityFile = data => async (dispatch, getState) => {
  const endpoint = `/life_settlement/api/opportunity_file/`;
  const activeOpportunity = activeOpportunitySelector(getState());
  data.opportunity_id = activeOpportunity.id;
  const response = await advisorhq.post(endpoint, data);
  dispatch({ type: types.CREATE_OPPORTUNITY_FILE, payload: response.data });
  notifications.success("A new Opportunity File was created");

  // update opportunity files
  let opportunityId = response.data.opportunity_id;
  const opportunityResponse = await advisorhq.get("/life_settlement/api/opportunity/" + opportunityId + "/");
  dispatch({ type: types.FETCH_OPPORTUNITY, payload: opportunityResponse.data });
};

export const editOpportunityFile = (opportunityFileId, newValues, row) => async (dispatch, getState) => {
  notifications.success("Saving...");

  const endpoint = `/life_settlement/api/opportunity_file/${opportunityFileId}/`;
  await advisorhq.patch(endpoint, newValues);

  // update opportunity files
  const activeOpportunity = activeOpportunitySelector(getState());
  let opportunityId = activeOpportunity && activeOpportunity.id;
  const opportunityResponse = await advisorhq.get("/life_settlement/api/opportunity/" + opportunityId + "/");
  dispatch({ type: types.FETCH_OPPORTUNITY, payload: opportunityResponse.data });
};

export const uploadOpportunityFile = file => async (dispatch, getState) => {
  notifications.success("Uploading Opportunity File...", file);
  const state = getState();
  const activeOpportunityFile = activeOpportunityFileSelector(state);
  const formData = new FormData();
  formData.append("id", activeOpportunityFile.id);
  formData.append("file", file, file.name);

  try {
    const response = await advisorhq.post(`/life_settlement/api/upload_opportunity_file/`, formData, {
      headers: {
        "Content-Type": "multipart/form-data",
      },
    });
    dispatch({ type: types.EDIT_OPPORTUNITY_FILE, payload: response.data });

    const activeOpportunity = activeOpportunitySelector(state);
    let opportunityId = activeOpportunity && activeOpportunity.id;

    // update opportunity files
    const getOpportunityResponse = await advisorhq.get("/life_settlement/api/opportunity/" + opportunityId + "/");
    dispatch({ type: types.FETCH_OPPORTUNITY, payload: getOpportunityResponse.data });

    notifications.clearAll();
    notifications.success("Opportunity File updated successfully");
  } catch (error) {
    notifications.error("Error creating new Opportunity File");
    console.error(error);
  }
};
